var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgErrorVoucher = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h24v24H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.063 4.967c.516-.974 1.358-.978 1.876 0l7.124 13.458c.516.974.045 1.77-1.057 1.77H4.996c-1.102 0-1.575-.792-1.057-1.77l7.124-13.458Zm.23 9.74A1 1 0 0 0 13.002 14V9a1 1 0 0 0-2 0v5a1 1 0 0 0 .293.707Zm0 3a1 1 0 1 0 1.415-1.414 1 1 0 0 0-1.415 1.414Z",
  fill: "#FF8B00"
})));
export default SvgErrorVoucher;